import emotion from "../icons/lockicon.png";
import verified from "../icons/personicon.png";
import family from "../icons/tursticon.png";     // 👈 match typo
import privacy from "../icons/verfiedicon.png";  // 👈 match typo

const icons = {
  emotion,
  verified,
  family,
  privacy,
};

export default icons;